import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import { ContentStyle, DataGridListStyle } from "../../Theme";
import { EPAFilters } from "../../components/EPAFilters";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import EPAHoldingQueueDetails from "./EPAHoldingQueueDetails";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { loadingEPAHoldingQueueCount } from "../../Redux/Slice/EPAHoldingQueueCountSlice";
import NoRecords from "../../components/NoRecords";
import { ViewClick } from "../../components/Content";
import ErrorOverlay from "../../components/ErrorOverlay";
import { REPORT_BASE_URL } from "../../Apis/Constants";

export default function EPAHoldingQueue(props: any) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [showFlow, setShowFlow] = useState(false);
  const [mxvalue, setMXValue] = useState("newrx");
  const [docId, setDocId] = useState("");
  const [docName, setDocName] = useState("");
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMXValue(event.target.value);
    setPage(0);
  };
  const handleShowMenuClick = () => {
    setShowMenu(!showMenu);
  };
  const [showMenu, setShowMenu] = React.useState(true);

  const columnsEPAHoldingQueue: GridColDef[] = [
    {
      field: "doctorName",
      headerName: "Doctor",
      width: 350,
      cellClassName: "w40",
      headerClassName: "w40",
    },
    {
      field: "prescriptionCount",
      headerName: "No of Prescriptions",
      width: 310,
      cellClassName: "w30",
      headerClassName: "w30",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "w30",
      headerClassName: "w30",
      renderCell: ({ row }) => (
        <ViewClick
          onClick={() => {
            setShowFlow(true);
          }}
        />
      ),
    },
  ];

  const EPAHoldingQueueState = useSelector((state: any) => {
    return { ...state.EPAHoldingQueueCountSlice };
  }); //redux data
  const [rowCountState, setRowCountState] = useState(
    EPAHoldingQueueState?.Pagination?.totalItems || 0
  );

  const dispatch = useDispatch();
  const EPAHoldingQueueCount = (nextPage: number) => {
    let paramsData = {
      pageNumber: nextPage,
      pageSize: pageSize,
      prescriptionType: mxvalue,
    };
    dispatch(loadingEPAHoldingQueueCount(paramsData));
  };

  useEffect(() => {
    EPAHoldingQueueCount(page);
  }, [page, mxvalue]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      EPAHoldingQueueState?.Pagination?.totalItems !== undefined
        ? EPAHoldingQueueState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [EPAHoldingQueueState?.Pagination?.totalItems, setRowCountState]);

  return (
    <>
      <ContentStyle>
        <Grid container item xs={12} spacing={0} alignItems="top">
          <Grid item xs={12}>
            {" "}
            <Box
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                position: "relative",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: 36,
                  position: "absolute",
                  top: 5,
                  right: 0,
                }}
              >
                <EPAFilters
                  showMenu={showMenu}
                  handleShowMenuClick={handleShowMenuClick}
                  mxvalue={mxvalue}
                  setMXValue={setMXValue}
                  handleChange={handleChange}
                />{" "}
              </Box>
            </Box>{" "}
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              EPA Holding Queue{" "}
              <HelpGuideTooltip
                content={
                  <>
                    {" "}
                    <Typography component="div" variant="body1">
                      This queue holds all Initiated, cancelled and errored EPAs
                      to process
                    </Typography>
                  </>
                }
                pdf={`${REPORT_BASE_URL}drx/PDF/EPA_User%20Manual_V2.3.pdf`}
                video={"https://vimeo.com/734716002/fe6e2d2110"}
              />
            </Typography>
          </Grid>

          {showFlow ? (
            <EPAHoldingQueueDetails
              mxvalue={mxvalue}
              docId={docId}
              docName={docName}
              setShowFlow={setShowFlow}
            />
          ) : (
            <Grid item xs={12}>
              {" "}
              <DataGridListStyle className="">
                <DataGrid
                  rows={EPAHoldingQueueState?.Items ?? []}
                  headerHeight={36}
                  sortingOrder={["desc", "asc"]}
                  columns={columnsEPAHoldingQueue}
                  autoHeight
                  rowHeight={40}
                  pageSize={pageSize}
                  disableSelectionOnClick
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  paginationMode="server"
                  getRowId={() => uuid()}
                  loading={EPAHoldingQueueState?.isLoading}
                  components={{
                    NoRowsOverlay: NoRecords,
                    NoResultsOverlay: NoRecords,
                    ErrorOverlay: ErrorOverlay,
                  }}
                  error={EPAHoldingQueueState?.error || undefined}
                  rowCount={rowCountState}
                  page={page}
                  rowsPerPageOptions={[pageSize]}
                  onRowClick={({ row }) => {
                    setShowFlow(true);
                    setDocId(row.doctorId);
                    setDocName(row.doctorName);
                  }}
                  onPageChange={(newPage) => {
                    setPage(newPage);
                  }}
                  getRowClassName={({ row }) => {
                    if (!row.onBehalf) {
                      return "PDoctor";
                    }
                    return "";
                  }}
                />
              </DataGridListStyle>
            </Grid>
          )}
        </Grid>{" "}
      </ContentStyle>
    </>
  );
}
